export const LOCAL_STORAGE_REDIRECT_KEY = 'googleSheetsRedirectUrl';
